import axios from 'axios';

// ✅ Dynamic baseURL for dev and production
const baseURL =
  process.env.NODE_ENV === 'production'
    ? 'https://shop.petrahcollection.co.ke/shop/routes'  // 🌐 Live server
    : 'http://localhost/shop/routes';                    // 🧪 Local dev

// ✅ Axios instance
const API = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true  // ✅ Enable session cookies (PHPSESSID)
});

// ✅ Optional: attach token for APIs that support it
API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;  // Optional, only if used
  }
  return req;
});

export default API;
